import React, { useEffect, useState, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { useForm } from "react-hook-form";
import { isEmpty } from "lodash";
import CommonPasswordInput from "../../common/component/commonPassword";
import useValidation from "../../common/utils/validationRules";
import CommonButton from "../../common/component/commonButton";
import { useToast } from "../../common/component/Toast";
import logoImg from "../../assests/images/sifo-lofo.png";
import { useTranslation } from "react-i18next";
import {
  decryptUsingAES256,
  encryptUsingAES256,
} from "../../common/utils/index";
import { useSelector, useDispatch } from "react-redux";
import { useLoader } from "../../common/component/LoaderProvider";
import CommonLoader from "../../common/component/commonLoader";
import { updatePassword } from "../../service/action/actioncreator/LoginAction/LoginAction";
import { onCommonReducerResetPswd } from "../../service/action/actioncreator/CommonAction/Common";
import { RESETPWDDATA } from "../../service/action/actiontype/CommonType/CommonType";

const ResetPassword = () => {
  const loading = useSelector(
    (state) => state.loginReducer.changePasswordLoading
  );
  const changePw = useSelector(
    (state) => state.loginReducer.changePasswordResponse
  );
  const buttonRef = useRef();
  const [validationFlag, setValidationFlag] = useState(false);
  const [notificationFlag, setNotificationFlag] = useState(false);
  const [successFlag, setSuccessFlag] = useState(false);
  const navigate = useNavigate();
  const { showToast } = useToast();
  const { validateField } = useValidation();
  const dispatch = useDispatch();
  const { t } = useTranslation("translation");
  const { showLoader, hideLoader } = useLoader();
  const resetpw = true;
  const resetPwdValue=useSelector((state)=>state.commonReducer.resetPwd)
  console.log("resetPwdValue",resetPwdValue)
  const {
    register,
    control,
    handleSubmit,
    formState: { errors },
    getValues,
    setValue,
    watch,
  } = useForm();

  watch("oldPassword");
  watch("newPassword");
  watch("confirmPassword");

  const onSubmit = (data) => {
    var id = localStorage.getItem("userId");
    var navigateFlag = true;
    var flag = true;
  
    if (
      !isEmpty(getValues("oldPassword")) &&
      !isEmpty(getValues("newPassword")) &&
      !isEmpty(getValues("confirmPassword"))
    ) {
      if (
        getValues("newPassword")?.trim() != getValues("confirmPassword")?.trim()
      ) {
        setValidationFlag(true);
      } else {
        if (
          !isEmpty(getValues("oldPassword")) &&
          !isEmpty(getValues("newPassword")) &&
          !isEmpty(getValues("confirmPassword"))
        ) {
          var headers = {
            UserId: parseInt(id),
            // OtpCode: 786589,
            AuthenticationType: 1,
            AuthenticationFor: "Reset Password",
            AccessIdentifier: "validate",
            IsPasswordReset:true,
          };
          var payload = {
            userId: parseInt(id),
            oldPassword: encryptUsingAES256(getValues("oldPassword")?.trim()),
            password: encryptUsingAES256(getValues("newPassword")?.trim()),
          };
          //  showToast
          // dispatch(updatePassword(payload,headers,navigate,showLoader,hideLoader,showToast,flag,setNotificationFlag,payloadOne,navigateFlag,removeItem))
          dispatch(
            updatePassword(
              payload,
              headers,
              navigate,
              showLoader,
              hideLoader,
              showToast,
              t,
              flag,
              setNotificationFlag
            )
          );
        }
      }
    }
  };
  const handleSuccessFn = () => {
    // navigate("/dashboard");
  
    let roleData=localStorage.getItem('roleId')
    dispatch(onCommonReducerResetPswd(false, RESETPWDDATA));
    if(roleData==='1'){
      navigate('/qcadmin')
    }else{
      navigate('/dashboard')
    }
   
    setNotificationFlag(false);
  };
  const handleRemoveData = () => {
    setValue("newPassword", "");
    setValue("confirmPassword", "");
  };
  const handleKeyDown = (event) => {
    if (event.key === "Enter") {
      buttonRef.current.click();
    }
  };

  useEffect(() => {
    if (isEmpty(getValues("oldPassword"))) {
      setValue("newPassword", "");
      setValue("confirmPassword", "");
    }
    if (isEmpty(getValues("newPassword"))) {
      setValue("confirmPassword", "");
    }
  }, [
    getValues("oldPassword"),
    getValues("newPassword"),
    getValues("confirmPassword"),
  ]);
  
  useEffect(() => {
    document.addEventListener("keydown", handleKeyDown);
    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, []);

  return (
    <>
      <div className="main-container pwd-btn">
        <div className="login-container">
          <div className="login-box text-center">
            <div className="display-flex">
              <img src={logoImg} alt="log-img" className="logo-img" />
            </div>
            <div className="login-form">
              {notificationFlag ? (
                <div className="login-success-pw ">
                  <div className="text-center custom-text-break text-break-forgot-pw font-size-fs-6 primary-text-color mt-4">
                    La modifica della password è avvenuta con successo.
                    Riceverai una mail di conferma.
                  </div>
                  <div className="mt-6">
                    <CommonButton
                      label={t("text_button_close")}
                      className="btn btn-cancel input-style-common btn-width btn-padding primary-text-color btn-cancel-style"
                      variant="cancel"
                      type="button"
                      onClick={handleSuccessFn}
                      inputStyle={true}
                    />
                  </div>
                </div>
              ) : (
                <>
                  <div className="mb-2">
                    <CommonPasswordInput
                      name="oldPassword"
                      placeholder={t("placeholder_old_password")}
                      register={register}
                      errors={errors}
                      validationFn={validateField}
                      control={control}
                      disabled={false}
                      inputStyle={true}
                    />
                  </div>
                  <div className="mt-4">
                    <CommonPasswordInput
                      name="newPassword"
                      placeholder={t("placeholder_new_password")}
                      register={register}
                      errors={errors}
                      validationFn={validateField}
                      control={control}
                      disabled={isEmpty(getValues("oldPassword"))}
                      inputStyle={true}
                      handleRemoveData={handleRemoveData}
                      resErrorFlag={errors.newPassword ? true : false}
                    />
                  </div>
                  <div className="mt-4">
                    <CommonPasswordInput
                      name="confirmPassword"
                      placeholder={t("placeholder_retype_password")}
                      register={register}
                      errors={errors}
                      validationFn={validateField}
                      control={control}
                      disabled={isEmpty(getValues("newPassword"))}
                      inputStyle={true}
                      handleRemoveData={handleRemoveData}
                      resErrorFlag={errors.confirmPassword ? true : false}
                    />
                  </div>

                  <div className="mt-6">
                    <CommonButton
                      label={t("text_button_cancel")}
                      className=" btn btn-cancel input-style-common btn-width btn-padding primary-text-color btn-cancel-style"
                      variant="cancel"
                      type="button"
                      onClick={handleSuccessFn}
                      inputStyle={true}
                    />
                    <CommonButton
                      label={t("text_button_save")}
                      disabled={isEmpty(
                        getValues("oldPassword") &&
                          getValues("newPassword") &&
                          getValues("confirmPassword")
                      )}
                      buttonRef={buttonRef}
                      onClick={handleSubmit(onSubmit)}
                      className="ms-4 btn btn-success btn-padding btn-width input-style-common text-white"
                      type="submit"
                      variant="success"
                      inputStyle={true}
                    />
                  </div>
                </>
              )}
              <div className="mt-5">
                {!notificationFlag && <hr />}
                {errors.oldPassword && (
                  <div className="p-error">{errors.oldPassword.message}</div>
                )}
                {errors.newPassword && (
                  <div className="p-error">{errors.newPassword.message}</div>
                )}
                {errors.confirmPassword && (
                  <div className="p-error">
                    {errors.confirmPassword.message}
                  </div>
                )}
                {validationFlag && !notificationFlag && (
                  <div className="p-error">{t("text_unmatch_password")}</div>
                )}
                {isEmpty(errors) && !validationFlag && !notificationFlag && (
                  <>
                    <div className="fw-bold mt-2 custom-text-break text-break-error font-size-fs-6">
                      {t("text_password_pattern_error_message")}
                    </div>
                  </>
                )}
              </div>
            </div>
            <CommonLoader loading={loading} />
          </div>
        </div>
      </div>
    </>
  );
};

export default ResetPassword;
